module.exports = __webpack_public_path__ + "media/images/MoreFilesIcon-01-a329eda9.png";